import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { FormPagFor } from '@/features/pagfor/page/form';

const RoutePagForParamsSchema = z.discriminatedUnion('action', [
    z.object({
        action: z.literal('cadastrar'),
        idpk: z.undefined().optional(),
    }),
    z.object({
        action: z.literal('visualizar'),
        idpk: z.string(),
    }),
]);

export type RoutePagForParams = z.infer<typeof RoutePagForParamsSchema>;

export const Route = createFileRoute('/a/pagfor/$action/{-$idpk}')({
    component: Component,
    params: {
        parse: (params) => {
            const result = RoutePagForParamsSchema.safeParse(params);

            return result.success ? result.data : false;
        },
    },
});

function Component() {
    const params = Route.useParams();

    return <FormPagFor {...params} />;
}
